import React, { useEffect } from 'react';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import ColumnChartSortingPopover from '../event/ColumnChartSortingPopover';
import { views } from '../../constants/event';
import ColumnChartFeaturesMenu from '../../utils/ColumnChartFeaturesMenu';

const ChartOptions = (props) => {
  const { view, isRetention, result, unit, toggleCumulative, cumulative } = props;
  const isShowSorting = view === views.COLUMN_CHART && !isRetention;

  const showCumulative =
    (result?.some((resultItem) =>
      resultItem.info.query.aggregations.find(({ type }) => type === 'TOTAL')
    ) ||
      unit?.compose?.events?.events.some((event) => event.aggregationType === 'sum')) &&
    view === views.CHART;

  useEffect(() => {
    if (!showCumulative && cumulative) {
      toggleCumulative(false);
    }
  }, [showCumulative, cumulative, toggleCumulative]);

  const renderMenu = () => <ColumnChartFeaturesMenu {...props} showCumulative={showCumulative} />;

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ marginRight: 10 }}>
        <Dropdown
          dropdownRender={renderMenu}
          trigger={['click']}
          getPopupContainer={(triggerNode) => triggerNode}
        >
          <a className="ant-dropdown-link">
            Features <DownOutlined />
          </a>
        </Dropdown>
      </div>
      {isShowSorting && <ColumnChartSortingPopover {...props} style={{ marginRight: 10 }} />}
    </div>
  );
};

export default ChartOptions;
